<script setup lang="ts">
import RadarSpinner from '@/components/common/RadarSpinner.vue'

// Inline spinner for small async states. Renders the brand radar mark; pass a
// Vuetify theme token via `color` to tint it (e.g. on colored backgrounds).
interface Props {
	size?: number
	color?: string
}

withDefaults(defineProps<Props>(), {
	size: 32,
	color: undefined,
})
</script>

<template>
	<RadarSpinner
		:size="size"
		:color="color"
	/>
</template>

<style scoped lang="scss"></style>
